import { ImportClickableTextEnum } from "@/Administration/Models/UI/ClickableTexts/ImportClickableTextEnum";
import { IGroupTabModel } from "@/Administration/Models/UI/Group/IGroupTabModel";
import { IUsersTabModel } from "@/Administration/Models/UI/Users/IUsersTabModel";
import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ClickableTextFilterTabComponent } from "./ClickableTextFilterTabComponent";
import { ClickableTextUsersComponent } from "./ClickableTextUsersComponent";

interface IClickableTextImportationPopupProps {
    clickableTextItems?: ClickableTextItem[];
    usersTabModel?: IUsersTabModel;
    groupsTabModel?: IGroupTabModel
    tab: ImportClickableTextEnum;
    isGroupMode: boolean;
}

class ClickableTextImportationState {
    public allClickableText: ClickableTextItem[];
    public newClickableTabItems: ClickableTextItem[];
    public selectedClickableText: ClickableTextItem;
    public nbOfTextList: number;
    public isAddButtonDisableForUserTAb: boolean;
    public selectAllTabsCallBack: ClickableTextItem[];
    public checkAllTabs: boolean;
    public tempListAdd: ClickableTextItem[];
}

class ClickableTextImportation extends React.Component<IClickableTextImportationPopupProps, ClickableTextImportationState> {
    private componentId = "import_clickableText";

    constructor(props: IClickableTextImportationPopupProps) {
        super(props);
        this.state = this.getInitialState(props);
    }

    public componentDidMount(): void {
        var elem = $("#" + this.componentId);
        var cnt = document.body;
        var dragOptions = {
            containment: cnt,
            handle: ".dragHandle",
            stop: function() {
                elem.draggable("destroy");
                window.setTimeout(() => elem.draggable(dragOptions), 80);
            }
        };
        elem.draggable(dragOptions);
        $(window).trigger("resize");

        sessionStore.showGlobalOverlay(true);
    }

    public componentDidUpdate(prevProps: IClickableTextImportationPopupProps): void {
        if (prevProps.tab !== this.props.tab
            || prevProps.clickableTextItems !== this.props.clickableTextItems
            || prevProps.isGroupMode !== this.props.isGroupMode
            || prevProps.usersTabModel !== this.props.usersTabModel
            || prevProps.groupsTabModel !== this.props.groupsTabModel
        ) {
            this.mutateState(s => {
                s.checkAllTabs = false;
                s.isAddButtonDisableForUserTAb = true;
                s.tempListAdd = [];
            });
        }

        $(window).trigger("resize");
    }

    public componentWillUnmount(): void {
        let elem = $("#" + this.componentId);
        elem.draggable("destroy");
        sessionStore.hideGlobalOverlay();
    }

    public render(): JSX.Element {
        let self = this;
        let tabAcss = "tab";
        let tabBcss = "tab";
        let width = 1300;
        if (self.props.tab == ImportClickableTextEnum.Employee)
            tabAcss += " open";
        else
            tabBcss += " open rb";

        let disabledAddButton: boolean = false;
        if (self.props.tab == ImportClickableTextEnum.Tab) {
            disabledAddButton = !(self.state.selectedClickableText != null);
        }
        else
            disabledAddButton = self.state.isAddButtonDisableForUserTAb;

        return (
            <div>
                <div className="popup admin-service-popup popup-with-grid" id={self.componentId} style={{ left: "50%", width: width + "px", marginLeft: -width / 2, top: "20%" }}>

                    <div className="portal-messages-header" style={{ height: "8%" }}>
                        <div className="itemGrow dragHandle" style={{ padding: "10px 5px", fontSize: "18px" }}>
                            <a className="close" aria-label="Close" onClick={() => self.closeClickableTextImport()}> ×</a>
                            <h4 className="uppercase">{cacheStore.GetString("ImportClickableText")}</h4>

                        </div>
                    </div>
                    <div className="p-body">
                        <div className="main-container">
                            <div className="tb tabs-container">
                                <div className="tbc t1">
                                    <div className={tabAcss}>
                                        <span onClick={() => self.setActiveTab(ImportClickableTextEnum.Employee)}>
                                            {this.props.isGroupMode ? cacheStore.GetString("GroupLabel") : cacheStore.GetString("EmployeeLabel")}
                                        </span>
                                    </div>
                                </div>
                                <div className="tbc t2"><div className={tabBcss}><span onClick={() => self.setActiveTab(ImportClickableTextEnum.Tab)}>{cacheStore.GetString("TabLabel")}</span></div></div>
                            </div>
                            {/* Body */}
                            {(self.props.tab === ImportClickableTextEnum.Employee && this.props.isGroupMode == false) && (
                                <ClickableTextUsersComponent
                                    allClickableTabNames={self.state.allClickableText.map(x => x.TabName)}
                                    textListCallback={text => self.onCheckOneTab(text)}
                                    selectAllTabsCallBack={tabs => self.mutateState(s => s.selectAllTabsCallBack = tabs)}
                                    newClickableTabItems={self.state.newClickableTabItems}
                                    allUsers={self.props.usersTabModel.get("AllUsersWithClickableText")}
                                    allListOfClickableText={self.props.usersTabModel.get("AllListOfClickableTextDetailsForSpecificUser")}
                                />
                            )}
                            {(self.props.tab === ImportClickableTextEnum.Employee && this.props.isGroupMode == true) && (
                                <ClickableTextUsersComponent
                                    allClickableTabNames={self.state.allClickableText.map(x => x.TabName)}
                                    textListCallback={text => self.onCheckOneTab(text)}
                                    selectAllTabsCallBack={tabs => self.mutateState(s => s.selectAllTabsCallBack = tabs)}
                                    newClickableTabItems={self.state.newClickableTabItems}
                                    allGroups={self.props.groupsTabModel.get("AllGroupsWithClickableText")}
                                    allListOfClickableText={self.props.groupsTabModel.get("AllListOfClickableTextDetailsForSpecificGroup")}
                                    isGroupMode={this.props.isGroupMode}
                                />
                            )}
                            {(self.props.tab === ImportClickableTextEnum.Tab && !this.props.isGroupMode) && (
                                <ClickableTextFilterTabComponent
                                    allClickable={self.state.allClickableText}
                                    textListCallback={textList => self.mutateState(s => s.selectedClickableText = textList)}
                                    tabsName={self.props.usersTabModel.get("AllTabNamesClickableTextForSpecificContext")}
                                    textList={self.props.usersTabModel.get("AllListOfClickableTextDetails")}
                                />
                            )}
                            {(self.props.tab === ImportClickableTextEnum.Tab && this.props.isGroupMode) && (
                                <ClickableTextFilterTabComponent
                                    allClickable={self.state.allClickableText}
                                    textListCallback={textList => self.mutateState(s => s.selectedClickableText = textList)}
                                    tabsName={self.props.groupsTabModel.get("AllTabNamesClickableTextForSpecificContext")}
                                    textList={self.props.groupsTabModel.get("AllListOfClickableTextDetails")}
                                    isGroupMode={true}
                                />
                            )}

                            {/* footer */}
                        </div>
                    </div>
                    <div className="p-footer">
                        <div className="text-left" style={{ width: "20%", float: "left", marginLeft: "5px" }}>
                            <ButtonControl
                                className="btn btn-primary"
                                disabled={(self.state.newClickableTabItems && self.state.newClickableTabItems.length > 0) ? false : true}
                                onClick={() => self.onClickRemove()}
                                label={cacheStore.GetString("RemoveLabel")}
                            />
                        </div>
                        <div className="text-right flex-display flex-align-items-center">
                            <div style={{ flexGrow: 1 }}>
                                <div style={{ float: "left", marginLeft: "70px" }}>
                                    {(self.props.tab == ImportClickableTextEnum.Employee && self.state.selectAllTabsCallBack && self.state.selectAllTabsCallBack.length > 0) && (
                                        <CheckboxControl
                                            id="employee_Check"
                                            label={cacheStore.GetString("SelectAllLabel")}
                                            checked={self.state.checkAllTabs}
                                            onChange={(checked: boolean) => self.checkAllTabs(checked)}
                                        />
                                    )}
                                </div>
                            </div>
                            <div style={{ float: "right" }}>
                                <ButtonGroup>
                                    {(self.state.nbOfTextList > 0) &&
                                        <span> {self.state.nbOfTextList + " " + cacheStore.GetString("InProgressLabel")} </span>
                                    }
                                    <ButtonControl
                                        className="btn btn-default"
                                        onClick={() => self.closeClickableTextImport()}
                                        label={cacheStore.GetString("CancelLabel")}
                                    />
                                    <ButtonControl
                                        className="btn btn-primary"
                                        disabled={disabledAddButton}
                                        onClick={() => self.addClickableText()}
                                        label={cacheStore.GetString("AddLabel")}
                                    />
                                    <ButtonControl
                                        className="btn btn-primary"
                                        disabled={(self.state.newClickableTabItems != null && self.state.newClickableTabItems.length > 0 && self.state.nbOfTextList > 0) ? false : true}
                                        onClick={() => self.saveOnClickText()}
                                        label={cacheStore.GetString("ImportLabel")}
                                    />
                                </ButtonGroup>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        );
    }

    private getInitialState(props: IClickableTextImportationPopupProps): ClickableTextImportationState {
        const initialState = new ClickableTextImportationState();
        initialState.selectedClickableText = null;
        initialState.nbOfTextList = 0;
        initialState.newClickableTabItems = [];
        initialState.allClickableText = props.clickableTextItems || [];
        initialState.isAddButtonDisableForUserTAb = true;
        initialState.selectAllTabsCallBack = [];
        initialState.checkAllTabs = false;
        initialState.tempListAdd = [];
        return initialState;
    }

    private mutateState(mutation: (s: ClickableTextImportationState) => void, then: () => void = null): void {
        let s = new ClickableTextImportationState();
        mutation(s);
        this.setState(s, then);
    }

    private closeClickableTextImport(): void {
        $(`#${this.componentId}`).draggable({ cancel: ".close" });
        this.mutateState(
            s => {
                s.newClickableTabItems = [];
                s.allClickableText = this.getAllUserClikableTabNames();
                s.nbOfTextList = 0;
                s.selectAllTabsCallBack = [];
            },
            () => window.setTimeout(() => {
                if (this.props.isGroupMode)
                    LocalEvent.Dispatch(LocalOperations.AdministrationGroup.CloseClickableTextImport);
                else
                    LocalEvent.Dispatch(LocalOperations.AdministrationUsers.CloseClickableTextImport);
            }, 50)
        );
    }

    private setActiveTab(tab: ImportClickableTextEnum): void {
        if (this.props.isGroupMode)
            sessionStore.dispatch(LocalOperations.AdministrationGroup.SetActivatedTabImportClickabeText, { Tab: tab });
        else
            sessionStore.dispatch(LocalOperations.AdministrationUsers.SetActivatedTabImportClickabeText, { Tab: tab });
    }

    private addClickableText(): void {
        let self = this;

        if (self.props.tab === ImportClickableTextEnum.Tab) {
            if (self.state.selectedClickableText != null) {
                if (self.state.newClickableTabItems.some(x => x.TabName == self.state.selectedClickableText.TabName) || self.state.newClickableTabItems.some(x => x.TabName == self.state.selectedClickableText.TabName)) {
                    sessionStore.showPopup({
                        title: cacheStore.GetString("WarningLabel"),
                        content: self.state.selectedClickableText.TabName + cacheStore.GetString("ReplaceNewTabLabel"),
                        showCancel: true,

                        okAction: () => {
                            let newList: ClickableTextItem[] = [];
                            newList = self.state.newClickableTabItems.filter(x => x.TabName != self.state.selectedClickableText.TabName);
                            newList.push(self.state.selectedClickableText);
                            self.mutateState(
                                s => {
                                    s.newClickableTabItems = newList;
                                    if (self.props.clickableTextItems.some(x => x.TabName == self.state.selectedClickableText.TabName)) {
                                        s.nbOfTextList = self.state.newClickableTabItems.length;
                                    }
                                    s.allClickableText = self.state.allClickableText;
                                    s.allClickableText = s.allClickableText.filter(x => x.TabName != self.state.selectedClickableText.TabName);
                                    s.allClickableText.push(self.state.selectedClickableText);
                                    s.selectedClickableText = null;
                                },
                                () => sessionStore.dispatch(this.props.isGroupMode
                                    ? LocalOperations.AdministrationGroup.CleanDetailsOfClickableText
                                    : LocalOperations.AdministrationUsers.CleanDetailsOfClickableText
                                )
                            );
                        }
                    });
                }

                else {
                    self.mutateState(
                        s => {
                            s.newClickableTabItems = self.state.newClickableTabItems;
                            s.newClickableTabItems.push(self.state.selectedClickableText);
                            s.nbOfTextList = self.state.nbOfTextList + 1;
                            s.selectedClickableText = null;
                            s.allClickableText = self.state.allClickableText;
                            s.allClickableText = s.allClickableText.filter(x => x.TabName != self.state.selectedClickableText.TabName);
                            s.allClickableText.push(self.state.selectedClickableText);
                        },
                        () => {
                            if (this.props.isGroupMode)
                                sessionStore.dispatch(LocalOperations.AdministrationGroup.CleanDetailsOfClickableText);
                            else
                                sessionStore.dispatch(LocalOperations.AdministrationUsers.CleanDetailsOfClickableText);
                        }
                    );
                }
            }
        }
        else { // Add new text in employee or group tabs
            self.mutateState(
                s => {
                    let strReapetedTabs: string[] = [];

                    s.newClickableTabItems = self.state.newClickableTabItems;

                    s.allClickableText = self.state.allClickableText;
                    s.tempListAdd = self.state.tempListAdd;
                    if (s.tempListAdd.length > 0) {
                        for (let text of s.tempListAdd) {
                            if (self.state.newClickableTabItems.some(x => x.TabName == text.TabName))
                                strReapetedTabs.push(text.TabName);

                            s.newClickableTabItems = s.newClickableTabItems.filter(x => x.TabName != text.TabName);
                            s.newClickableTabItems.push(text);
                        }
                    }

                    for (let text of s.newClickableTabItems) {
                        if (text.IsChecked) {
                            s.allClickableText = s.allClickableText.filter(x => x.TabName != text.TabName);
                            s.allClickableText.push(text);
                        }
                    }
                    if (strReapetedTabs.length > 0) {
                        let text = strReapetedTabs.join(", ");
                        sessionStore.showPopup({
                            title: cacheStore.GetString("WarningLabel"),
                            content: `${cacheStore.GetString("ReplacedSomeTabLabel")}( ${text} )`
                        });
                    }

                    s.tempListAdd = [];
                    s.checkAllTabs = false;

                    s.nbOfTextList = s.newClickableTabItems.length;
                    s.isAddButtonDisableForUserTAb = true;
                },
                () => {
                    if (this.props.isGroupMode)
                        sessionStore.dispatch(LocalOperations.AdministrationGroup.CleanDetailsOfClickableText);
                    else
                        sessionStore.dispatch(LocalOperations.AdministrationUsers.CleanDetailsOfClickableText);
                }
            );
        }
    }

    private onClickRemove(): void {
        let self = this;
        // for remove temp list
        self.mutateState(
            s => {
                if (!this.props.isGroupMode)
                    s.allClickableText = self.props.usersTabModel.get("EmployeeClickableTextItems");
                else
                    s.allClickableText = self.props.groupsTabModel.get("GroupClickableTextItems");
                s.newClickableTabItems = [];
                s.nbOfTextList = 0;
                s.isAddButtonDisableForUserTAb = true;

                s.selectAllTabsCallBack = [];
            },
            () => {
                if (this.props.isGroupMode)
                    sessionStore.dispatch(LocalOperations.AdministrationGroup.CleanDetailsOfClickableText);
                else
                    sessionStore.dispatch(LocalOperations.AdministrationUsers.CleanDetailsOfClickableText);
            }
        );
    }

    private saveOnClickText(): void {
        if (this.props.isGroupMode)
            sessionStore.dispatch(LocalOperations.AdministrationGroup.SaveClickableTextImport, { TextList: this.state.newClickableTabItems });
        else
            sessionStore.dispatch(LocalOperations.AdministrationUsers.SaveClickableTextImport, { TextList: this.state.newClickableTabItems });
    }

    private getAllUserClikableTabNames(): ClickableTextItem[] {
        let names = [];
        if (this.props.clickableTextItems) {
            names.push(this.props.clickableTextItems.map(x => x.TabName));
        }

        if (this.state.newClickableTabItems)
            names.push(this.state.newClickableTabItems);

        return names;
    }

    private onCheckOneTab(item: SearchableItemModelT<ClickableTextItem>): void {
        let self = this;
        self.mutateState(s => {
            s.newClickableTabItems = self.state.newClickableTabItems;
            s.tempListAdd = self.state.tempListAdd;
            item.Model.IsChecked = !item.Model.IsChecked;

            if (item.Model.IsChecked)
                s.tempListAdd.push(item.Model);

            if (!item.Model.IsChecked)
                s.tempListAdd = s.tempListAdd.filter(x => x.TabName != item.Model.TabName);

            s.isAddButtonDisableForUserTAb = s.tempListAdd.length > 0 ? false : true;
        });
    }

    private checkAllTabs(checked: boolean): void {
        let self = this;
        if (self.state.selectAllTabsCallBack != null && self.state.selectAllTabsCallBack.length > 0) {
            self.mutateState(s => {
                s.checkAllTabs = checked;
                let allText = self.state.selectAllTabsCallBack.map(i => { i.IsChecked = checked; return i; });

                s.newClickableTabItems = self.state.newClickableTabItems;
                s.tempListAdd = self.state.tempListAdd;

                for (let text of allText) {
                    if (text.IsChecked) {
                        s.tempListAdd.push(text);
                    }
                    if (!text.IsChecked)
                        s.tempListAdd = s.tempListAdd.filter(x => x.TabName != text.TabName);
                }
                s.isAddButtonDisableForUserTAb = s.tempListAdd.length > 0 ? false : true;
            });
        }
    }
}

export { ClickableTextImportation };
